import { render, staticRenderFns } from "./IviewButtonGroup.vue?vue&type=template&id=a8c7115e&scoped=true&"
import script from "./IviewButtonGroup.vue?vue&type=script&lang=js&"
export * from "./IviewButtonGroup.vue?vue&type=script&lang=js&"
import style0 from "./IviewButtonGroup.vue?vue&type=style&index=0&id=a8c7115e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8c7115e",
  null
  
)

export default component.exports